"use client";
import type { ReactNode } from "react";
import { useCallback, useState } from "react";
import { ExpandableIndicator } from "@jetblue/kit/expandable-indicator";

export type LinkSetCollapseButtonProperties = {
  children?: ReactNode;
};
export const LinkSetCollapseButton = ({
  children,
  ...properties
}: LinkSetCollapseButtonProperties) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => {
    setIsOpen((current) => !current);
  }, [setIsOpen]);
  return (
    <button
      aria-expanded={isOpen}
      className="
        group/expandable-ui peer flex items-center justify-between p-4
        text-start text-body font-extrabold text-foreground-primary-variant
        outline-0 transition-all

        data-[open=false]:hover:bg-sky-blue/15

        data-[open=false]:focus:bg-sky-blue/15

        md:hidden
      "
      data-fs-element="footer-menu-button"
      data-open={isOpen}
      onClick={toggle}
      type="button"
      {...properties}
    >
      {children}
      <ExpandableIndicator />
    </button>
  );
};
